﻿export function profilePageData(state = {}, action) {
    switch (action.type) {
        case 'PROFILE_PAGE_LOADED':
            return { ...state, ...action.data };

        default:
            return state;
    }
}